import { PropsWithChildren, createContext, useContext } from 'react';

import { useCreatePurchaseReturn } from './create-purchase-return.hook';

type CreatePurchaseReturnContext = ReturnType<typeof useCreatePurchaseReturn>;

export const CreatePurchaseReturnContext =
    createContext<CreatePurchaseReturnContext | null>(null);

export const CreatePurchaseReturnProvider = ({
    children,
}: PropsWithChildren) => {
    const value = useCreatePurchaseReturn();

    return (
        <CreatePurchaseReturnContext.Provider value={value}>
            {children}
        </CreatePurchaseReturnContext.Provider>
    );
};

export const useCreatePurchaseReturnContext = () => {
    const context = useContext(CreatePurchaseReturnContext);

    if (!context) {
        throw new Error(
            'useCreatePurchaseReturnContext must be used within CreatePurchaseReturnProvider',
        );
    }

    return context;
};
